import { capitalize } from './strings';

export const formatDataForSubmission = ({ formData, selectedCity, roomsData, amenities }) => {
  const formattedData = {
    email: formData.email,
    name: formData.name,
    phone: formData.phone,
    city: capitalize(selectedCity),
    district: formData.district,
    total_rooms: parseInt(formData.rooms),
    total_bathrooms: parseInt(formData.bathrooms),
    rooms_data: roomsData.map((room) => ({
      size_range: room.size_range,
      is_suite: room.is_suite || false,
      has_terrace: room.has_terrace || false,
      has_balcony: room.has_balcony || false,
      exposure: room.exposure,
      has_ac: room.has_ac || false,
      has_ventilator: room.has_ventilator || false,
    })),
    property_data: {
      size: parseInt(formData.squareMeters),
      has_salon: amenities.has_salon || false,
      has_terrace: amenities.has_terrace || false,
      has_balcony: amenities.has_balcony || false,
      has_natural_light: amenities.has_natural_light || false,
      has_ac: amenities.has_ac || false,
      has_ventilator: false, // Default to false if not provided
      has_elevator: amenities.has_elevator || false,
      floor_height: formData.floor,
    },
  };

  return formattedData;
};
